import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  API_URL = environment.apiUrl;

  constructor(private _http: HttpClient) { }

  getRestaurantDataByRestaurantId(id) {
    return this._http.post(this.API_URL + '/restaurant/web/info', { restaurant_id: id });
  }
}
